import components from'./components';
import directives from'./directives';
import plugins from'./plugins';

const plugin =
{
    install( app )
    {
        for( const prop in components )
        {
            const component = components[prop]; app.component( component.name || component.__name, component );
        }

        for( const prop in plugins )
        {
            const plugin = plugins[prop]; plugin.install( app );
        }

        for( const prop in directives )
        {
            const directive = directives[prop]; app.directive( prop, directive );
        }
    }
}

export default plugin;